import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire and forget promo event. Never blocks or breaks the click it is attached to.
export function trackEvent(event, { offer, placement } = {}) {
  axios
    .post(`${API}/track`, {
      event,
      offer: offer || null,
      placement: placement || null,
      page: window.location.pathname,
    })
    .catch(() => {});
}

// Reads campaign tags off the current URL so the enquiry form can attribute
// itself. Supports both our short tags (?offer=&from=) and standard UTMs,
// since ad platforms append utm_* by default.
export function readSource(search, pathname) {
  const params = new URLSearchParams(search || "");
  const placement =
    params.get("from") ||
    params.get("utm_source") ||
    params.get("utm_medium") ||
    null;
  const campaign = params.get("utm_campaign");
  return {
    source_page: pathname || null,
    source_offer: params.get("offer") || null,
    source_placement: campaign && placement
      ? `${placement} / ${campaign}`
      : placement || campaign || null,
  };
}
